<template>
  <woot-modal :show.sync="show" :on-close="onCancel" modal-type="right-aligned">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('CAMPAIGN.EVALUATIONS.ADD.TITLE')"
        :header-content="$t('CAMPAIGN.EVALUATIONS.ADD.TITLE')"
      />
      <div class="evaluation--form">
        <InputField
          v-model="evaluation.name"
          :label="$t('CAMPAIGN.EVALUATIONS.ADD.NAME.LABEL')"
          :placeholder="$t('CAMPAIGN.EVALUATIONS.ADD.NAME.PLACEHOLDER')"
          :error="
            $v.evaluation.name.$error
              ? $t('CAMPAIGN.EVALUATIONS.ADD.NAME.ERR')
              : ''
          "
          :info-list="[]"
          @blur="$v.evaluation.name.$touch"
        />
        <InputField
          v-model="evaluation.prompt"
          :label="$t('CAMPAIGN.EVALUATIONS.ADD.PROMPT.LABEL')"
          :placeholder="$t('CAMPAIGN.EVALUATIONS.ADD.PROMPT.PLACEHOLDER')"
          :error="
            $v.evaluation.prompt.$error
              ? $t('CAMPAIGN.EVALUATIONS.ADD.PROMPT.ERR')
              : ''
          "
          :info-list="[]"
          type="textarea"
          :rows="5"
          @blur="$v.evaluation.prompt.$touch"
        />
        <MultiselectDropdown
          :label="$t('CAMPAIGN.EVALUATIONS.ADD.TYPE.LABEL')"
          :error="
            $v.evaluation.kind.$error
              ? $t('CAMPAIGN.EVALUATIONS.ADD.TYPE.ERR')
              : ''
          "
        >
          <multiselect
            v-model="evaluation.kind"
            class="column small-12"
            :options="typeList"
            track-by="id"
            label="title"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :disabled="false"
            :placeholder="$t('CAMPAIGN.EVALUATIONS.ADD.TYPE.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            @close="$v.evaluation.kind.$touch"
          />
        </MultiselectDropdown>

        <ToggleField
          :value="evaluation.active"
          :label="$t('CAMPAIGN.EVALUATIONS.ADD.ACTIVE.LABEL')"
          class-name="evaluation_active"
          @onToggle="evaluation.active = $event"
        />

        <MultiselectDropdown
          v-if="isAgentSpeficif"
          :label="$t('CAMPAIGN.EVALUATIONS.ADD.AI_AGENT.LABEL')"
          :error="
            $v.evaluation.agent.$error
              ? $t('CAMPAIGN.EVALUATIONS.ADD.AI_AGENT.ERR')
              : ''
          "
        >
          <multiselect
            v-model="evaluation.agent"
            class="column small-12"
            :options="llm_bots"
            track-by="id"
            label="name"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :disabled="false"
            :placeholder="$t('CAMPAIGN.EVALUATIONS.ADD.AI_AGENT.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            :max-height="200"
          />
        </MultiselectDropdown>

        <MultiselectDropdown
          v-if="isAgentSpeficif"
          :label="$t('CAMPAIGN.EVALUATIONS.ADD.TRIGERS.LABEL')"
          :error="''"
        >
          <CheckboxInput
            v-model="evaluation.settings.ai_conversation_end"
            :class-name-wrapper="'evaluation_triger'"
            :label="$t('CAMPAIGN.EVALUATIONS.ADD.TRIGERS.LIST.CONVERSATION')"
            @onToggle="onToggleTriger('ai_conversation_end')"
          />
          <CheckboxInput
            v-model="evaluation.settings.human_handover"
            :class-name-wrapper="'evaluation_triger'"
            :label="$t('CAMPAIGN.EVALUATIONS.ADD.TRIGERS.LIST.HUMAN')"
            @onToggle="onToggleTriger('human_handover')"
          />
          <CheckboxInput
            v-model="evaluation.settings.conversation_resolved"
            :class-name-wrapper="'evaluation_triger'"
            :label="$t('CAMPAIGN.EVALUATIONS.ADD.TRIGERS.LIST.SESSION')"
            @onToggle="onToggleTriger('conversation_resolved')"
          />
        </MultiselectDropdown>

        <div class="medium-12 columns mt_20">
          <woot-button
            class="campaign_btn"
            variant="primary"
            :is-disabled="uiFlagsEval.isCreating || uiFlagsEval.isUpdating"
            :is-loading="uiFlagsEval.isCreating || uiFlagsEval.isUpdating"
            @click="onSubmit"
          >
            {{ $t('CAMPAIGN.EVALUATIONS.ADD.BTNS.SUBMIT') }}
          </woot-button>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import InputField from 'components/ui/inputs/InputField.vue';
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import CheckboxInput from 'components/ui/inputs/CheckboxInput.vue';
import ToggleField from 'components/ui/inputs/ToggleField.vue';
import { EVALUATION_TYPES, EVALUATION_TYPE } from './evaluationConstant';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    InputField,
    MultiselectDropdown,
    CheckboxInput,
    ToggleField,
  },
  mixins: [alertMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editEvaluation: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      evaluation: {
        name: '',
        prompt: '',
        kind: '',
        agent: '',
        active: true,
        settings: {
          ai_conversation_end: false,
          human_handover: false,
          conversation_resolved: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      uiFlagsEval: 'evaluations/getUIFlags',
      uiFlags: 'llmbots/getUIFlags',
      llm_bots: 'llmbots/getLLMBots',
    }),
    typeList() {
      return EVALUATION_TYPES.map(el => ({ ...el, title: this.$t(el.title) }));
    },
    isAgentSpeficif() {
      return this.evaluation.kind?.id === EVALUATION_TYPE.AGENT_SPECIFIC;
    },
  },
  validations() {
    return {
      evaluation: {
        active: {},
        name: { required },
        prompt: { required },
        kind: { required },
        agent: { required },
      },
    };
  },
  async mounted() {
    this.populateForm(this.editEvaluation);
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('success');
    },
    async onSubmit() {
      this.$v.evaluation.name.$touch();
      this.$v.evaluation.prompt.$touch();
      this.$v.evaluation.kind.$touch();

      if (this.isAgentSpeficif) {
        this.$v.evaluation.agent.$touch();
      }

      const isNameInvalid = this.$v.evaluation.name.$error;
      const isPromptInvalid = this.$v.evaluation.prompt.$error;
      const isKindInvalid = this.$v.evaluation.kind.$error;

      let isAgentInvalid = false;
      if (this.isAgentSpeficif) {
        isAgentInvalid = this.$v.evaluation.agent.$error;
      }
      if (isNameInvalid || isPromptInvalid || isKindInvalid || isAgentInvalid) {
        return;
      }

      const payload = {
        name: this.evaluation.name,
        prompt: this.evaluation.prompt,
        kind: this.evaluation.kind?.id,
        active: this.evaluation.active,
      };
      if (this.isAgentSpeficif) {
        payload.llm_chatbot_id = this.evaluation.agent?.id;
        payload.settings = this.evaluation.settings;
      }

      try {
        if (this.editEvaluation?.id) {
          await this.$store.dispatch('evaluations/updateEvaluationById', {
            evaluation_id: this.editEvaluation.id,
            payload,
          });
          this.showAlert(
            this.$t('CAMPAIGN.EVALUATIONS.ADD.BTNS.SUCCESS_MSG_UPDATE')
          );
        } else {
          await this.$store.dispatch('evaluations/createEvaluation', payload);
          this.showAlert(this.$t('CAMPAIGN.EVALUATIONS.ADD.BTNS.SUCCESS_MSG'));
        }
        this.onSuccess();
      } catch (error) {
        console.error('Error in creating/updating evaluation:', error);
        this.showErrAlert(error, 'Something went wrong!');
      }
    },
    onToggleTriger(triger) {
      this.evaluation.settings[triger] = !this.evaluation.settings[triger];
    },
    populateForm(newData) {
      this.evaluation.name = newData?.name;
      this.evaluation.prompt = newData?.prompt;
      this.evaluation.kind = this.typeList.find(el => el.id === newData?.kind);
      this.evaluation.agent = this.llm_bots.find(
        el => el.id === newData?.llm_chatbot_id
      );
      this.evaluation.active =
        newData?.active !== undefined ? newData.active : true;
      this.evaluation.settings = newData?.settings || this.evaluation.settings;
    },
  },
};
</script>

<style scoped lang="scss">
.evaluation--form {
  padding: var(--space-normal) var(--space-large) var(--space-large);

  .columns {
    padding: 0 var(--space-smaller);
  }
}

.input-group-label {
  font-size: var(--font-size-small);
}
</style>

<style>
.evaluation_triger {
  margin-bottom: 8px !important;
}

.evaluation_active {
  margin: 16px 0 !important;
}
</style>
